/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Subtitle import form" |
*
* @param {Subtitle_Import_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_form_label = /** @type {((inputs?: Subtitle_Import_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire d'importation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Importformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di importazione dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма импорта субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de importación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导入表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕インポートフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक आयात फ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de importação de legendas")
	return /** @type {LocalizedString} */ ("Subtitle import form")
});